import React, { useState, useEffect } from 'react';
// @material-ui/core components
import { withStyles } from '@material-ui/core/styles';
import styles from 'assets/jss/material-dashboard-react/views/dashboardStyle.js';
// core components
import Button from 'components/CustomButtons/Button.js';
import Table from 'components/Table/Table.js';
import SearchForm from 'components/Search/SearchRelatoriosOperacoes';
import Search from '@material-ui/icons/Search';
import Circular from 'components/Circular/Circular';
import { getAllEvents } from '../../services/events/events';
import { getAllLockers } from "../../services/lockers/lockers";

import moment from 'moment';

class RelatoriosOperacoes extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showButtonSearch: true,
      showForm: false,
      lockerAPI: [],
      finalResultAPI: [],
      users: null,
      codeAndOperations: null,
      circular: true,
      joinLockers: [],
      selected: props.selected,
      allLockers: []
    };
  }

  componentDidMount() {
    this.handleGetAPI();
  }

  handleGetAPI = async () => {
    const { lockers, groups } = this.props;
    let allLockers = [];

    getAllLockers((los) => {
      los.push({ id: null, group_lockers: null });
      los.forEach((locker, index) => {
        if (lockers.find(l => l.value == locker.id) || groups.find(g => g.value == locker.group_lockers)) {
          getAllEvents(locker.id, (data) => {
            let dataVal = data.data.filter(d => d.code > 50);
            dataVal.forEach(dl => {
              dl['name'] = locker.name;
              dl['group'] = locker.group_lockers;
            });
            allLockers.push(...dataVal);

            if (index == los.length - 1) {
              this.setState({ circular: false, allLockers });
              this.joinAllLockers();
            }
          });
        } else {
          if (index == los.length - 1) {
            this.setState({ circular: false, allLockers });
            this.joinAllLockers();
          }
        }
      });
    });
  };

  joinAllLockers = () => {
    const { allLockers } = this.state;
    allLockers.sort((a, b) => moment(b.date) - moment(a.date));

    this.setState({ joinLockers: allLockers });
  };

  handleFilterTable = (field, value, dateFromValue, dateToValue, codeValue, userValue, groupVal, lockerVal, origenSelectVal) => {
    this.joinAllLockers();

    const { joinLockers } = this.state;

    let filteredData;

    groupVal = (groupVal) ? groupVal : {};
    lockerVal = (lockerVal) ? lockerVal : {};
    origenSelectVal = (origenSelectVal) ? origenSelectVal : {};

    filteredData = joinLockers.filter(
      (el) => {
        return (((codeValue) ? el.code === codeValue : true) && ((lockerVal && !lockerVal.value) ? true : (el.lockerId === lockerVal.value)) && ((groupVal && !groupVal.value) ? true : (el.group === groupVal.value)) && ((userValue) ? el.usuario === userValue : true) && ((dateFromValue) ? el.date >= dateFromValue.toISOString().substring(0, 11) + '00:00:00.000Z' : true) && ((dateToValue) ? el.date <= dateToValue.toISOString().substring(0, 11) + '23:59:59.000Z' : true));
      }
    );

    switch (origenSelectVal.value) {
      case "manage":
        filteredData = filteredData.filter(f => f.code >= 100);
        break;
      case "locker":
        filteredData = filteredData.filter(f => f.code < 100);
        break;
    }

    filteredData.sort((a, b) => moment(b.date) - moment(a.date));
    this.setState({
      joinLockers: filteredData,
      showForm: false,
      showButtonSearch: true,
    });

  };

  handleSearch = () => {
    const { showForm } = this.state;

    this.setState({
      showForm: !showForm,
      showButtonSearch: false,
    });

    this.joinAllLockers();
  };

  render() {
    const {
      circular,
      showForm,
      showButtonSearch,
      joinLockers,
      allLockers
    } = this.state;

    const codeAndOperation = [];

    const map = new Map();

    for (const item of allLockers) {
      if (!map.has(item.code)) {
        map.set(item.code, true);
        switch (item.code) {
          case '100':
            codeAndOperation.push({
              codigo: item.code,
              operacao: 'Usuário adicionado'.toUpperCase(),
            });
            break;
          case '101':
            codeAndOperation.push({
              codigo: item.code,
              operacao: 'Usuário atualizado'.toUpperCase(),
            });
            break;
          case '102':
            codeAndOperation.push({
              codigo: item.code,
              operacao: 'Usuário excluído'.toUpperCase(),
            });
            break;
          default:
            codeAndOperation.push({
              codigo: item.code,
              operacao: item.complemento.replace(/[0-9]/g, 'X').toUpperCase(),
            });
        }
      }
    }

    allLockers.sort((a, b) => b.date - a.date);

    const dataColumn = [
      'Id',
      'Operação',
      'Locker',
      'Porta',
      'Encomenda',
      'Usuário',
      'Tempo de Operação',
      'Gerado em',
    ];

    // a api recebe como dados um array de objetos.
    // a tabela recebe como dados um array de arrays. Aqui eu faço um map nos dados da api e retorno
    // um array de arrays com os valores da API convertidos para elementos do array final
    const dataTable = joinLockers.map((data) => [
      data.code,
      data.complemento.toUpperCase(),
      data.name,
      (data.parametro1 && (data.parametro1.includes(':') || !isNaN(data.parametro1))) ? '' : data.parametro1,
      (data.encomenda && data.encomenda.length > 20) ? data.encomenda.substring(0, 12) : data.encomenda,
      data.usuario,
      (data.parametro1 && data.parametro1.includes(':')) ? data.parametro1 : data.time,
      moment(data.date)
        .utcOffset((new Date().getTimezoneOffset()/60) * -1)
        .format('DD/MM/YYYY HH:mm:ss'),
    ]);

    return circular ? (
      <Circular />
    ) : (
        <div>
          <SearchForm
            show={showForm}
            filterTable={this.handleFilterTable}
            groups={this.props.groups}
            lockers={this.props.lockers}
            groupedLockers={this.props.groupedLockers}
            operations={codeAndOperation
              .filter((cod) => cod.codigo !== null)
              .sort((a, b) => Number(a.codigo) - Number(b.codigo))}
          />
          <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>
            <Button onClick={this.handleSearch} color="primary" show={showButtonSearch}>
              <Search />
            PESQUISA
          </Button>
          </div>

          <Table
            tableHead={dataColumn}
            tableData={dataTable.length > 0 ? dataTable : [['Nada encontrado']]}
            tableHeaderColor="primary"
          />
        </div>
      );
  }
}

export default withStyles(styles)(RelatoriosOperacoes);
